import React, { useEffect } from 'react'
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { serverConn } from "../API/apiRequest"
import { logout } from "../State/Slice/userSlice"
import { IRootState } from "../State/Store"
import { LoadingPage } from "./Employer/EmailActivation/EmailActivation"

const Logout: React.FC = ()=>{

    const user = useSelector((state: IRootState)=> state.user)
    const dispatch = useDispatch()
  
    useEffect(()=>{
      async function doLogout(){
        try{
            if(user.logId){   
                await serverConn.post(`/logout/${user.logId}`)
            }
            localStorage.removeItem('user')
            dispatch(logout())
        }catch(e){
          localStorage.removeItem('user')
          dispatch(logout())        
        }
      }
  
      doLogout()
    },[dispatch, user.logId])
    return(
      <LoadingPage />
    )
  }
export default Logout